// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bestellliste-tsx": () => import("./../../../src/pages/bestellliste.tsx" /* webpackChunkName: "component---src-pages-bestellliste-tsx" */),
  "component---src-pages-datenschutz-tsx": () => import("./../../../src/pages/datenschutz.tsx" /* webpackChunkName: "component---src-pages-datenschutz-tsx" */),
  "component---src-pages-impressum-tsx": () => import("./../../../src/pages/impressum.tsx" /* webpackChunkName: "component---src-pages-impressum-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-medien-tsx": () => import("./../../../src/pages/medien.tsx" /* webpackChunkName: "component---src-pages-medien-tsx" */),
  "component---src-templates-vortrag-tsx": () => import("./../../../src/templates/vortrag.tsx" /* webpackChunkName: "component---src-templates-vortrag-tsx" */)
}

